// Redux Store Configuration with RTK Query
import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import rootReducer from './rootReducer';
import { baseApi } from './api/baseApi';

// Import module APIs to ensure endpoints are injected into baseApi
import '../app/modules/pm-shri/services/api';
import '../app/modules/kvs-samagam/services/kvsSamagamApi';
import '../app/modules/Attendance/services/attendanceApi';
import '../app/modules/dashboard/services/api';
import '../app/modules/result/services/api';
import '../app/modules/student-holistic/services/holisticApi';
import '../app/modules/admission/services/admissionApi';

export const store = configureStore({
  reducer: {
    ...rootReducer,
    [baseApi.reducerPath]: baseApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(baseApi.middleware),
});

// DISABLED: setupListeners was causing refetches on tab focus/reconnect
// which overloaded the database with multiple connections
// setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
